import React, { useRef, useState } from "react";
import { UploadIcon, Loader2Icon } from "lucide-react";
export const FileUploadButton = ({ onFileSelect, background }) => {
    const fileInputRef = useRef(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };
    const handleFileChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            setIsProcessing(true);
            const handleFileProcessing = async (selectedFile) => {
                try {
                    await onFileSelect(selectedFile);
                }
                finally {
                    setTimeout(() => {
                        setIsProcessing(false);
                    }, 500); // Small delay to ensure the processing state is visible
                }
            };
            handleFileProcessing(file);
            // Reset the input field so the same file can be selected again
            event.target.value = '';
        }
    };
    let backgroundClass = background === 'white' ? 'bg-white' : 'bg-gray-900';
    let textColor = background === 'white' ? 'text-gray-600' : 'text-white';
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: "file", hidden: true, ref: fileInputRef, onChange: handleFileChange, accept: ".pdf,.doc,.docx,.jpg,.png,.heic" }),
        React.createElement("button", { onClick: handleButtonClick, disabled: isProcessing, className: `w-10 h-10 rounded-full ${backgroundClass} border border-gray-200 hover:border-orange-300 hover:bg-orange-50 flex items-center justify-center transition-all duration-300 group shadow-sm ${isProcessing ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`, title: isProcessing ? "Processing..." : "Upload file" }, isProcessing ? (React.createElement(Loader2Icon, { className: `w-5 h-5 ${textColor} animate-spin` })) : (React.createElement(UploadIcon, { className: `w-5 h-5 ${textColor} group-hover:text-orange-500` })))));
};
